import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DownloaderService {
  private startUrl = `${environment.apiBaseUrl}/rtcm-downloader/start`;
  private urlUrl = `${environment.apiBaseUrl}/rtcm-downloader/download_url`;

  constructor(private http: HttpClient) {}

  start(
    mountpoint: string,
    durationSec?: number,
    planStartAt?: string,
    scheduleLeadMin?: number,
    overrides?: { server?: string; username?: string; password?: string; userId?: string }
  ): Observable<any> {
    const body: any = { mountpoint };
    if (durationSec != null) body.durationSec = durationSec;
    if (planStartAt) body.planStartAt = planStartAt;
    if (scheduleLeadMin != null) body.scheduleLeadMin = scheduleLeadMin;
    if (overrides) {
      if (overrides.server) body.server = overrides.server;
      if (overrides.username) body.username = overrides.username;
      if (overrides.password) body.password = overrides.password;
      if (overrides.userId) body.userId = overrides.userId;
    }
    return this.http.post(this.startUrl, body, { observe: 'response' });
  }

  getDownloaderUrl(mountpoint: string): Observable<{ url: string; expiresAt: string; lastModified?: string; running?: boolean }> {
    return this.http.get<{ url: string; expiresAt: string; lastModified?: string; running?: boolean }>(this.urlUrl, { params: { mountpoint } });
  }
}


